<template>
  <!-- 是否可以清空
       @author: 王汝鹏
       @date: 2019-9-15
   -->
  <div class="setting-item">
    <el-form-item label="是否可清空"> 
      <el-radio-group v-model="clearable" size="small">
        <el-radio-button :label="false">否</el-radio-button>
        <el-radio-button :label="true">是</el-radio-button>
      </el-radio-group>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 是否可以清空
     *  @description 将 isClearable 字段映射到当前 clearable 计算属性
     *  @return {Boolean}
     *  @author 王汝鹏
     *  @version 2019-09-10
     */
    ...mapComputed({
      clearable: { 
        parent: i => i.baseOption,
        attr: "isClearable" 
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingIsClearable.vue